/**
 * @class ClickoutBehavior
 * @extends Mn.Behavior
 */
export class ClickoutBehavior extends Mn.Behavior {

    options () {

        return {
            andSelf: true,
            eventName: 'clickout',
            ignoreDetachedNodes: false
        };
    }

    initialize () {

        if (typeof window === 'object') {

            let eventName = 'click.' + _.uniqueId('out');
            let $document = $(document);

            setTimeout(() => { $document.on(eventName, this.clickOut.bind(this)); }, 0);
            this.on('destroy', () => { $document.off(eventName); });
        }
    }

    clickOut (evtObj) {

        let $target = $(evtObj.target);

        if (this.options.ignoreDetachedNodes && !$target.closest(document).length) {
            return;
        }

        if (this.options.andSelf) {

            if (!$target.closest(this.$el).length) {
                this.triggerEvent();
            }
        } else {

            if (!this.$(evtObj.target).length) {
                this.triggerEvent();
            }
        }
    }

    triggerEvent () {

        this.view.triggerMethod(this.options.eventName);
    }
}



// WEBPACK FOOTER //
// ./shared/behavior/ClickoutBehavior.js